import { useToast } from "../contexts/ToastContext";
import { TOAST_TIME_TIME } from "../shared/constants";

export function useCopyToClipboard() {
  const { show } = useToast();

  const copy = (text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        // Mostrar mensagem de sucesso
        show({
          severity: "success",
          summary: "Copiado!",
          detail: "Texto copiado para a área de transferência",
          life: TOAST_TIME_TIME,
        });
      })
      .catch((err) => {
        console.error("Erro ao copiar texto: ", err);
        show({
          severity: "error",
          summary: "Erro",
          detail: "Não foi possível copiar o texto",
          life: TOAST_TIME_TIME,
        });
      });
  };


  return { copy };
}
